export enum TNA_TRACK_LOCATION_TYPES {
  ALLOW_ANY_LOCATION = "36c417c7-444a-4cef-94c2-42810fa5b13c",
  ALLOW_ANY_WITH_FLAG = "18adf09b-be55-48a2-89e7-771d3b52e97d",
  ALLOW_ONLY_PREDEFINED = "15c3d2da-de10-4fe8-acb8-036e2a112980",
  NOT_NEEDED = "3ad1a102-a9f3-4267-83eb-d36d9639de7f",
}
